"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageBackendDataProvider = void 0;
const useStorageList_1 = require("./useStorageList");
function useStorageBackendDataProvider(entityName, mapEntityFilterData) {
    return (request) => {
        const response = (0, useStorageList_1.useStorageList)(entityName, {
            filter: mapEntityFilterData(request.filterData),
            orderBy: request.sortColumnKey === '_updated'
                ? []
                : [{ column: request.sortColumnKey, desc: request.sortColumnDesc }],
            orderByUpdatedDesc: request.sortColumnKey === '_updated' ? request.sortColumnDesc : undefined,
            limit: request.limit,
            offset: request.offset,
        });
        return {
            data: response.data
                ? {
                    filteredRowCount: response.data.total,
                    rows: response.data.rows,
                }
                : undefined,
            error: response.error,
            isLoading: response.isLoading,
            reload: response.mutate,
        };
    };
}
exports.useStorageBackendDataProvider = useStorageBackendDataProvider;
